import { useCallback } from 'react';
import validateConfigRow from '../utils/validateConfigRow';

export default function useValidateConfigs({ setToast, setPending }) {
  const validateAll = useCallback((rows) => {
    if (!rows?.length) return;

    const validated = rows.map((row, idx) => {
      const issues = validateConfigRow(row);
      return {
        ...row,
        issues,
        Validated: issues.length === 0,
        _originalIndex: idx, 
      };
    });

    const sorted = [...validated].sort((a, b) => {
      const aHasIssues = a?.Validated === false;
      const bHasIssues = b?.Validated === false;
      if (aHasIssues && !bHasIssues) return -1;
      if (!aHasIssues && bHasIssues) return 1;
      return (a._originalIndex ?? 0) - (b._originalIndex ?? 0);
    });

    setPending(sorted);

    const failed = validated.filter(r => !r.Validated).length;
    setToast({
      open: true,
      message: failed ? `${failed} row(s) have validation issues.` : 'All rows validated successfully.',
      severity: failed ? 'warning' : 'success',
    });
  }, [setToast, setPending]);

  return { validateAll };
}
